/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
export type IShipmentFragment = { __typename?: 'Shipment' } & Pick<
  Types.IShipment,
  | 'id'
  | 'currentStopSequence'
  | 'firstPickupStartAt'
  | 'isExternal'
  | 'marketplaceId'
  | 'missingInfo'
  | 'missingInfoUrgencyMessage'
  | 'motorCarrierId'
  | 'mpPodState'
  | 'podUploaded'
  | 'status'
  | 'trailerType'
  | 'vin'
> & {
    customer?: Types.Maybe<{ __typename?: 'Customer' } & Pick<Types.ICustomer, 'id' | 'name'>>
    drivers?: Types.Maybe<
      Array<
        { __typename?: 'Driver' } & Pick<
          Types.IDriver,
          | 'id'
          | 'createdAt'
          | 'firstName'
          | 'lastName'
          | 'motorCarrierId'
          | 'name'
          | 'transfixUserId'
        >
      >
    >
    etaObject?: Types.Maybe<
      { __typename?: 'EtaObject' } & Pick<Types.IEtaObject, 'eta' | 'drivingDistance' | 'onTime'>
    >
    motorCarrier: { __typename?: 'MotorCarrier' } & Pick<
      Types.IMotorCarrier,
      'id' | 'name' | 'mcNumber' | 'dotNumber' | 'legalName'
    >
    stops: Array<
      { __typename?: 'Stops' } & Pick<
        Types.IStops,
        | 'relativeStopSequence'
        | 'city'
        | 'countryCode'
        | 'displayTimezone'
        | 'endAt'
        | 'id'
        | 'marketplaceId'
        | 'shipmentId'
        | 'startAt'
        | 'stateCode'
        | 'stopSequence'
        | 'stopType'
      > & {
          address: { __typename?: 'Address' } & Pick<
            Types.IAddress,
            | 'addressLine1'
            | 'addressLine2'
            | 'addressee'
            | 'countryCode'
            | 'displayTimezone'
            | 'locality'
            | 'postalCode'
            | 'subdivisionCode'
          >
        }
    >
    trackingSummary?: Types.Maybe<
      { __typename?: 'ShipmentTrackingSummary' } & Pick<
        Types.IShipmentTrackingSummary,
        'isTracking' | 'shouldBeTracking'
      >
    >
    trailer?: Types.Maybe<
      { __typename?: 'Trailer' } & Pick<Types.ITrailer, 'id' | 'number' | 'trailerType'>
    >
    truck?: Types.Maybe<
      { __typename?: 'Truck' } & Pick<Types.ITruck, 'id' | 'entityId' | 'truckNumber'>
    >
  }

export const ShipmentFragmentDoc = gql`
  fragment Shipment on Shipment {
    id
    currentStopSequence
    customer {
      id
      name
    }
    drivers {
      id
      createdAt
      firstName
      lastName
      motorCarrierId
      name
      transfixUserId
    }
    etaObject {
      eta
      drivingDistance
      onTime
    }
    firstPickupStartAt
    isExternal
    marketplaceId
    motorCarrier {
      id
      name
      mcNumber
      dotNumber
      legalName
    }
    missingInfo
    missingInfoUrgencyMessage
    motorCarrierId
    mpPodState
    podUploaded
    status
    stops {
      relativeStopSequence
      address {
        addressLine1
        addressLine2
        addressee
        countryCode
        displayTimezone
        locality
        postalCode
        subdivisionCode
      }
      city
      countryCode
      displayTimezone
      endAt
      id
      marketplaceId
      shipmentId
      startAt
      stateCode
      stopSequence
      stopType
    }
    trackingSummary {
      isTracking
      shouldBeTracking
    }
    trailer {
      id
      number
      trailerType
    }
    trailerType
    truck {
      id
      entityId
      truckNumber
    }
    vin
  }
`
